import moment from "moment";
import objectUtils from "../../../../utils/objectUtils";

export enum EFilterType {
    Is = "IS",
    IsNot = "IS NOT",
    DateBefore = "DATE BEFORE",
    DateAfter = "DATE AFTER",
}

class Filter {
    private static IsDate(filterValue: any) {
        const reg =
            /\b(\d{4}[-/]\d{1,2}[-/]\d{1,2}|\d{1,2}[-/]\d{1,2}[-/]\d{4}|\d{1,2}\/\d{1,2}\/\d{4}|\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z|\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?Z|\d{1,2} [A-Z][a-z]{2} \d{4}|\d{1,2}-[A-Z][a-z]{2}-\d{4})\b/;

        if (typeof filterValue === "string") return reg.test(filterValue);

        return filterValue instanceof Date;
    }

    private filterMap: Record<
        EFilterType,
        (obj: any, filterValue: any, isCaseSensitive?: boolean) => boolean
    > = {
        [EFilterType.Is]: (obj, filterValue, isCaseSensitive) => {
            if (typeof obj === "string")
                return (
                    isCaseSensitive ? (obj as string).toString().includes((filterValue as string)) : (obj as string).toString().toLowerCase().includes((filterValue as string).toLowerCase())
                );

            if (obj instanceof Date && Filter.IsDate(filterValue))
                return moment(obj).isSame(filterValue, "day");

            if (Array.isArray(obj) && Array.isArray(filterValue))
                return objectUtils.softIncludes(obj, filterValue);

            if (Array.isArray(obj)) return obj.includes(filterValue);

            return obj === filterValue;
        },
        [EFilterType.IsNot]: (obj, filterValue, isCaseSensitive) => {
            return !this.filterMap[EFilterType.Is](obj, filterValue, isCaseSensitive);
        },
        [EFilterType.DateBefore]: (obj, filterValue) => {
            if (obj instanceof Date)
                return (
                    moment(obj).isBefore(filterValue, "day") ||
                    moment(obj).isSame(filterValue, "day")
                );
            return false;
        },
        [EFilterType.DateAfter]: (obj, filterValue) => {
            if (obj instanceof Date)
                return (
                    moment(obj).isAfter(filterValue, "day") ||
                    moment(obj).isSame(filterValue, "day")
                );
            return false;
        },
    };

    getSupport<T>(obj: T): EFilterType[] {
        return Object.keys(this.filterMap)
            .filter((filterType) => {
                const filter = filterType as EFilterType;

                if (filter === EFilterType.IsNot)
                    return !this.filterMap[filter](obj, obj);

                return this.filterMap[filter](obj, obj);
            })
            .map((filterType) => filterType as EFilterType);
    }

    filter<T>(
        obj: T,
        filterType: EFilterType,
        filterValue: string | number | Date,
        isCaseSensitive?: boolean
    ): boolean {
        const comparisonFunction = this.filterMap[filterType];
        if (comparisonFunction) return comparisonFunction(obj, filterValue, isCaseSensitive);
        throw new Error("Unsupported filter");
    }
}
const filter = new Filter();
export default filter;
